import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'

import { EditTriviaListDetails } from './edit-trivia-list-details'
import { useQueryUserTriviaList } from '../queries/useQueryUserTriviaList'
import { useUpdateUserTriviaList } from '../queries/useUpdateUserTriviaList'
import { useUserTriviaListImageStorageFolder } from '../queries/useUserTriviaListImageStorageFolder'

interface RouteParams {
  listId: string
}

export const EditTriviaListDetailsRoute = observer(() => {
  const { listId } = useParams<RouteParams>()
  const { data, isLoading, isSuccess } = useQueryUserTriviaList(listId)

  const { isLoading: isSaving, mutate: updateTriviaList } = useUpdateUserTriviaList({
    listId
  })

  const storageFolder = useUserTriviaListImageStorageFolder()

  if (isLoading) return <Spinner />

  if (!isSuccess) return null

  return (
    <EditTriviaListDetails
      imageStorageFolder={storageFolder}
      initialValues={data}
      isSaving={isSaving}
      updateTriviaList={updateTriviaList}
    />
  )
})
